import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom';

import App from './containers/App';

// import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';

import './styles/index.css';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Route path="/" component={App} />
        </Router>
    </Provider>,
    document.getElementById('root')
);

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js